import { PROGRAM_LEVELS } from '@src/graphql/queries/programLevel';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useProgramLevels = ({ searchText, countryCode, isActive, initialPageSize = 25, }) => {
    const { page, setPage, pageSize, setPageSize, total, items: programLevels, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        spec: {
            name: searchText,
            countryCode: countryCode || undefined,
            isActive,
            includeCountries: true,
        },
        fetchQuery: PROGRAM_LEVELS,
        dataProp: 'programLevels',
        initialPageSize,
        initialSort: {
            orderBy: 'numCountries',
            orderByDir: 'desc',
        },
    });
    return {
        programLevels,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
